import { useEffect, useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { Helmet } from 'react-helmet-async'
import { AppHeader } from '../../common/app-header'
import contactImg from '../../images/img-ttl-contact.svg'
import { checkSize, convertFileToBase64, intervalId } from '../../common/support-util'

import axios from "axios";
import {
    ErrorInfo,
    required,
    emailRegexp,
    maxLength,
} from "../../common/Validator";

interface AppContactsFrom {
    email?: string;
    category?: string;
    message?: string;
    file?: any;
}
interface Category {
    category: string;
    title: string;
}

export const AppContacts = () => {
    const [hide, setHide] = useState(false)
    const [categories, setCategories] = useState<Category[]>();
    const [btnClz, setBtnClz] = useState(["btnSubmit"])
    const history = useHistory();
    const {
        register,
        formState: { errors },
        handleSubmit,
        setValue
    } = useForm<AppContactsFrom>();

    // 送信処理(web側バリデーション通過後)
    const onSubmit: SubmitHandler<AppContactsFrom> = async (
        data: AppContactsFrom
    ) => {
        const sendData = {
            ...data,
            // 画像をdataurlに変換して更新
            file: await convertFileToBase64(data.file),
        }

        setBtnClz([...btnClz, "sending"])// くるくるアイコン
        await axios.post("/api/v1/sp/app/contacts", sendData)
            .then(() => {
                setHide(true)
                clearInterval(intervalId)
            })
            .catch(() => history.push("/errors/400"))
            ;
    };

    useEffect(() => {


        // 初回はemailを取得する
        // useEffectではasync-awaitが使えないのでcallback形式で書く
        axios.get("/api/v1/sp/app/contacts/const")
            .then((result) => {
                setValue('email', result.data?.email)
                setCategories(result.data?.categories)

                // qa=requestの場合に「ご意見・ご要望」を選択、それ以外は「アプリ・サービスのご利用について」
                const queries = /q=([^&]+)/.exec(window.location.search)

                setValue("category", (queries && queries[1]) === "request" ? "OPINION" : "SERVICE")
            })
            .catch((e) => history.push("/errors/400"));

    }, [history, setValue]);

    return (
        <div className='contact'>
            <Helmet title="お問い合わせ | Family Works" />
            <AppHeader titleText="お問い合わせ" img={contactImg} imgAlt="CONTACT" />

            <main className="wrapper">
                {!hide && <>
                    <p className="contactExplain"><span className="kome">&#8251;</span>は必須項目です。</p>
                    <section className="secContact">
                        <form onSubmit={handleSubmit(onSubmit)} id="formContact">
                            <ul className="formlist">
                                <li className="formlist__half">
                                    <dl>
                                        <dt><label>問い合わせ項目 <span className="kome">&#8251;</span></label></dt>
                                        <dd>
                                            <select
                                                {...register("category", { required })}
                                                id="frm-category" tabIndex={1} autoFocus>
                                                {categories?.map((item, idx) => (
                                                    <option value={item.category} key={idx}>
                                                        {item.title}
                                                    </option>
                                                ))}
                                            </select>
                                        </dd>
                                        <dd className="errmsg"></dd>
                                    </dl>
                                </li>
                                <li className="required">
                                    <dl>
                                        <dt><label htmlFor="frm-email">メールアドレス <span className="kome">&#8251;</span></label></dt>
                                        <dd><input
                                            {...register("email", {
                                                required,
                                                pattern: emailRegexp,
                                                ...maxLength(254),
                                            })}
                                            type="email" id="frm-email" maxLength={254} placeholder="メールアドレス" tabIndex={5} /></dd>
                                        <ErrorInfo error={errors.email} />
                                    </dl>
                                </li>
                                <li className="formlist__full required">
                                    <dl>
                                        <dt><label htmlFor="frm-msg">問い合わせ内容 <span className="kome">&#8251;</span></label></dt>
                                        <dd><textarea
                                            {...register("message", { required })}
                                            id="frm-msg" cols={50} rows={5} placeholder="問い合わせ内容" tabIndex={7}></textarea></dd>
                                        <ErrorInfo error={errors.message} />
                                    </dl>
                                </li>
                                <li>
                                    <dl>
                                        <dt><label htmlFor="frm-attached">画像ファイル (最大10MB)</label></dt>
                                        <dd><input
                                            {...register("file", {
                                                validate: {
                                                    lessThan10Mb: (v) => checkSize(v),
                                                },
                                            })}
                                            type="file"
                                            accept="image/jpeg, image/png, image/gif"
                                            id="frm-attached" tabIndex={4} /></dd>
                                        <ErrorInfo error={errors.file} />
                                    </dl>
                                </li>
                            </ul>
                            <div className={btnClz.join(' ')}>
                                <div className="iconSpinner"></div>
                                <input type="submit" name="submit" value="送信" tabIndex={8} />
                            </div>
                        </form>
                        <p className="contactNote">お問い合わせの受付完了メールおよび担当者からの回答は、入力いただいたメールアドレスへ送信いたします。また、お問い合わせ内容によっては回答いたしかねる場合もございますので、あらかじめご了承ください。なお、土日祝日、年末年始（12/30～1/3）にいただいたお問い合わせは、翌営業日以降に順次ご回答いたします。</p>
                    </section>
                </>}
                {hide && <section className="secContactSent">
                    <p className="secContactSent__title">送信されました。</p>
                    <p className="secContactSent__txt">お問い合わせを受け付けました。</p>
                </section>}
            </main>
        </div>
    );
};
